export default __webpack_public_path__ + "static/video2-e4da883be5631a7263796fbf12fdc929.mp4";